import React, { createContext, useState, useEffect } from "react";
import { setLanguage as setGlobalLanguage, getLanguage as getGlobalLanguage } from "../components/configure/utils";

const DEFAULT_LANGUAGE = "th";
const STORAGE_KEY = "_sandee_language";

export const LanguageContext = createContext({
  language: DEFAULT_LANGUAGE,
  setLanguage: () => {},
});

export const LanguageProvider = ({ children }) => {
  const [language, setLocalLanguage] = useState(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored || DEFAULT_LANGUAGE;
  });

  useEffect(() => {
    // Ensure the global translation language matches the state
    setGlobalLanguage(language);
  }, [language]);

  const switchLanguage = (lang) => {
    if (language !== lang) {
      setLocalLanguage(lang);
      localStorage.setItem(STORAGE_KEY, lang);
      setGlobalLanguage(lang);
    }
  };

  return <LanguageContext.Provider value={{ language, setLanguage: switchLanguage }}>{children}</LanguageContext.Provider>;
};

export const getCurrentLanguage = () => {
  const storedLang = localStorage.getItem(STORAGE_KEY);
  return storedLang || getGlobalLanguage();
};
